import React from "react";
import AnimatedRoutes from "./AnimatedRoutes";

const Main = () => {
  return <AnimatedRoutes />;
};

export default Main;
